var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnarchive = function SvgUnarchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3174a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 20H6a2 2 0 0 1-2-2V8h16v10a2 2 0 0 1-2 2h-1M6 4h12l2 4H4zM12 20v-6m0 0-2.5 2.5M12 14l2.5 2.5"
  })));
};
export default SvgUnarchive;